import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';
import { API_BASE_URL } from '@config';

export const SET_TWO_STEP_VERIFICATION_SETTINGS = 'SET_TWO_STEP_VERIFICATION_SETTINGS';
export const SET_TWO_STEP_VERIFICATION_ERROR = 'SET_TWO_STEP_VERIFICATION_ERROR';

export const setTwoStepVerificationSettings = (data) => ({
  type: SET_TWO_STEP_VERIFICATION_SETTINGS,
  payload: data,
});

export const setTwoStepVerificationError = (data) => ({
  type: SET_TWO_STEP_VERIFICATION_ERROR,
  payload: data,
});

export const getTwoStepVerificationSettings = () => (dispatch) => {
  const url = `${API_BASE_URL}/api/two-step-verification/settings`;
  return axios
    .get(url)
    .then((response) => {
      dispatch(setTwoStepVerificationSettings(response.data.data));
      return response.data.data;
    })
    .catch((err) => {
      dispatch(setTwoStepVerificationError({ ...err.response, type: 'modal' }));
      throw err;
    });
};

export const updateTwoStepVerificationSettings = (settings) => (dispatch) => {
  const url = `${API_BASE_URL}/api/two-step-verification/settings`;

  // Only send enabled and allowedDomains fields
  const dataToSend = {
    enabled: settings.enabled,
    allowedDomains: settings.allowedDomains || '',
  };

  return axios
    .put(url, dataToSend)
    .then(() => {
      dispatch(showMessage({ message: 'Two Step Verification settings updated successfully' }));
      dispatch(getTwoStepVerificationSettings()); // Refresh settings after update
      return true;
    })
    .catch((err) => {
      const errorMsg = err.response?.data?.message || 'Error updating Two Step Verification settings';
      dispatch(setTwoStepVerificationError({ ...err.response, type: 'modal' }));
      dispatch(showMessage({ message: errorMsg, variant: 'error' }));
      throw err;
    });
};
